'use client';

import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

// Campo de contraseña con "ojito" para mostrar/ocultar lo escrito (regla del
// cliente: TODO campo de contraseña lo lleva) y mensaje de error opcional
// debajo. El estilo base es el del Input; cada pantalla ajusta con className.
export default function InputPassword({
  error = null,
  className,
  ...props
}: Omit<React.ComponentProps<typeof Input>, 'type'> & {
  error?: string | null;
}) {
  const [ver, setVer] = useState(false);
  return (
    <div>
      <div className="relative">
        <Input
          type={ver ? 'text' : 'password'}
          aria-invalid={error ? true : undefined}
          className={cn('pr-11', className)}
          {...props}
        />
        <button
          type="button"
          tabIndex={-1}
          className="absolute right-2 top-1/2 flex size-8 -translate-y-1/2 items-center justify-center rounded-lg text-muted-foreground transition-colors duration-150 hover:bg-muted hover:text-foreground"
          onClick={() => setVer((v) => !v)}
          aria-label={ver ? 'Ocultar contraseña' : 'Mostrar contraseña'}
          title={ver ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        >
          {ver ? <EyeOff className="size-4" /> : <Eye className="size-4" />}
        </button>
      </div>
      {error && <p className="mt-1.5 text-xs font-medium text-destructive">{error}</p>}
    </div>
  );
}
